import { render, staticRenderFns } from "./StepGrupoFamiliar.vue?vue&type=template&id=73b73e77"
import script from "./StepGrupoFamiliar.vue?vue&type=script&lang=js"
export * from "./StepGrupoFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports